<template>
  <div>
    <main-image-section />
    <div class="container">
      <div class="row">
        <div class="col text-center font-default">
          <div class="block p-t">
            <h2 class="fnt font-deco">
              {{ $t("SHARE_PAGE__TITLE") }}
            </h2>
            <p v-if="customMsg" v-html="customMsg"></p>
            <p v-html="$t('SHARE_PAGE__INTRO')"></p>
          </div>

          <div class="content-narrow">
            <div class="block p-t">
              <el-button
                v-if="supportShareAPI"
                type="info"
                @click="shareAPI"
                class="w100"
              >
                {{ $t("SHARE_PAGE__SHARE_CONTEST") }}
                <i class="fas fa-share"></i>
              </el-button>

              <social-sharing
                v-else
                :url="url"
                :title="$t('SHARED__APP_TITLE')"
                :description="$t('SHARED__APP_DESCRIPTION')"
                twitter-user="tuango"
                inline-template
              >
                <div>
                  <network network="facebook">
                    <a class="c-share-btn c-share-btn--fb" href="javascript:;"
                      ><i class="fab fa-facebook-f"></i
                      >{{ $t("SHARE_PAGE__FACEBOOK_BTN") }}</a
                    >
                  </network>
                  <network network="twitter">
                    <a class="c-share-btn c-share-btn--tw" href="javascript:;"
                      ><i class="fab fa-twitter"></i
                      >{{ $t("SHARE_PAGE__TWITTER_BTN") }}</a
                    >
                  </network>
                </div>
              </social-sharing>
            </div>
          </div>

          <div class="block">
            <h4 class="fnt font-deco" v-html="$t('SHARE_PAGE__MERCI')"></h4>
          </div>

          <div class="content-narrow">
            <div class="block p-b">
              <el-button @click="gotoTuango" type="primary" class="w100">
                {{ $t("SHARE_PAGE__VISIT_TUANGO_BTN") }}
              </el-button>
            </div>

            <div class="block p-b">
              <el-button
                v-if="token"
                @click="gotoMyPlane"
                type="primary"
                class="w100"
              >
                {{ $t("SHARE_PAGE__MY_PLANE_BTN") }}
                <i class="fas fa-plane"></i>
              </el-button>
            </div>
          </div>

          <div class="content-narrow">
            <a :href="extrernalLink" class="external_link" target="_blank">
              {{
                destination && destination.externalLinkFr
                  ? $t("SHARED__VISIT_WINGBUDDY_DESTINATION")
                  : $t("SHARED__VISIT_WINGBUDDY")
              }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex"
import SocialSharing from "vue-social-sharing"

import MainImageSection from "../components/Layout/MainImageSection"
import UserService from "@/services/api/UserService"
import to from "await-to-js"

const { mapGetters } = createNamespacedHelpers("app")
const userService = new UserService()

export default {
  name: "Share",
  components: {
    MainImageSection,
    SocialSharing
  },
  props: {
    customMsg: {
      type: String
    }
  },
  data() {
    return {
      token: null,
      userId: null,
      destination: null
    }
  },
  computed: {
    ...mapGetters(["utmQs"]),
    url() {
      return (
        "https://" +
        process.env[`VUE_APP_DOMAIN_${this.$i18n.locale.toUpperCase()}`]
      )
    },
    shareData() {
      return {
        title: this.$t("SHARED__APP_TITLE"),
        text: this.$t("SHARED__APP_DESCRIPTION"),
        url: this.url
      }
    },
    supportShareAPI() {
      return !!navigator.share
    },
    extrernalLink() {
      let url =
        this.$i18n.locale === "fr"
          ? "https://www.wingbuddy.com/voyages"
          : "https://www.wingbuddy.com"

      if (this.destination && this.destination.externalLinkFr) {
        url = this.destination.externalLinkFr
      }

      return url
    }
  },
  methods: {
    gotoMyPlane() {
      this.$router.push({
        name: "status",
        query: { t: this.token, u: this.userId }
      })
    },
    gotoTuango() {
      window.location.assign(
        `https://www.tuango.ca/${this.$i18n.locale}/category/escapades/?${this.utmQs}`
      )
    },
    gotoIDC() {
      const url =
        this.$i18n.locale === "fr"
          ? "https://www.idcdermo.com/ca_fr/?utm_campaign=concours_solis&utm_medium=affiliate&utm_source=tuango&utm_content=idc_dermo"
          : "https://www.idcdermo.com/ca_en/?utm_campaign=concours_solis&utm_medium=affiliate&utm_source=tuango&utm_content=idc_dermo"
      window.location.assign(url)
    },
    async shareAPI() {
      try {
        await navigator.share(this.shareData)
      } catch (err) {
        console.error(err)
      }
    }
  },

  async created() {
    this.token = this.$route.query.t
    this.userId = this.$route.query.u

    const [, user] = await to(userService.get(this.userId, this.token))

    if (user && user.destination) {
      this.destination = user.destination
    }
  }
}
</script>

<style scoped>
.external_link {
  font-size: 18px;
  text-decoration: underline;
}
</style>
